export const MISSING_RESPONSE = "I don't know";

export const DEFAULT_NO_ANSWER_RESPONSE =
  'Sorry, no answer could be found for that question, try asking it a different way. Otherwise, contact support directly.';

export const enum WidgetMode {
  POPUP = 'popup',
  SLIDE_OVER = 'slide-over',
}
